import { Component, Type } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyFieldConfig, FormlyFieldProps } from '@ngx-formly/core';
import { TimeSpanComponent } from './time-span.component';

interface TimeSpanProps extends FormlyFieldProps {
  canSpanOverMidnight?: boolean;
}

export interface FormlyTimeSpanFieldConfig extends FormlyFieldConfig<TimeSpanProps> {
  type: 'timespan' | Type<FormlyTimeSpanComponent>;
}

@Component({
  imports: [ReactiveFormsModule, TimeSpanComponent],
  selector: 'vectronic-formly-time-span-wrapper',
  template: `<vectronic-formly-time-span
    [formControl]="formControl"
    [canSpanOverMidnight]="props?.canSpanOverMidnight"
    [defaultValue]="field?.defaultValue"
    [label]="props?.label"
    [required]="props?.required"
    [id]="id"
  />`,
})
export class FormlyTimeSpanComponent extends FieldType<FieldTypeConfig<TimeSpanProps>> {}
